import { FC, PropsWithChildren } from 'react';

// Note: Conform 1.x keeps each form's state in the form itself, so there is no app-wide form provider anymore
export const GlobalProviders: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <>{children}</>;
};
